/**
 * Rounds a number to a specified number of decimal places.
 * Useful for avoiding floating-point precision issues (e.g., 5.5 * 0.9 = 4.949999999999998).
 *
 * @param value - The number to round
 * @param decimals - The number of decimal places (default: 10)
 * @returns The rounded number
 *
 * @example
 * roundToDecimals(4.949999999999998) // => 4.95
 * roundToDecimals(5.5 * 0.9) // => 4.95
 * roundToDecimals(1.005, 2) // => 1.01
 */
export function roundToDecimals(value: number, decimals: number = 10): number {
    return Number(value.toFixed(decimals));
}
